/*@flow*/
import * as t from 'lib/t';

export default t.subtype(t.Object, v => v && !v.isEmpty(), 'NonEmptyList');
